import { useStaticQuery, graphql } from "gatsby"
import React from "react"

import Grid from "./grid"
import {
  FooterWrapper,
  MappedinInfo,
  ImageContainer,
  Address,
  SocialIconsContainer,
  Copyright,
  DividingLine,
  Title,
  SiteNavigationContainer,
  SiteNavListGroup,
  SiteNavItem,
  SiteNavGroupTitle,
  IndustriesListGroup,
  NavListItemGrid,
} from "./footer.styles"
import externalLinks from "../../external-links"

import EmailSignupForm from "./footer.email-submission"

const Footer = () => {
  const getUrl = (item) => item.edges[0].node.publicURL
  const { mappedinLogoSrc, fbIcon, instagramIcon, linkedinIcon, twitterIcon } =
    useStaticQuery(graphql`
      query {
        mappedinLogoSrc: allFile(
          filter: { relativePath: { eq: "0_Header_Footer/mappedin_logo.svg" } }
        ) {
          edges {
            node {
              publicURL
            }
          }
        }
        fbIcon: allFile(
          filter: { relativePath: { eq: "0_Header_Footer/fb_icon.svg" } }
        ) {
          edges {
            node {
              publicURL
            }
          }
        }
        instagramIcon: allFile(
          filter: { relativePath: { eq: "0_Header_Footer/instagram_icon.svg" } }
        ) {
          edges {
            node {
              publicURL
            }
          }
        }
        linkedinIcon: allFile(
          filter: { relativePath: { eq: "0_Header_Footer/linkedin_icon.svg" } }
        ) {
          edges {
            node {
              publicURL
            }
          }
        }
        twitterIcon: allFile(
          filter: { relativePath: { eq: "0_Header_Footer/twitter_icon.svg" } }
        ) {
          edges {
            node {
              publicURL
            }
          }
        }
      }
    `)
  return (
    <FooterWrapper>
      <Grid addMargin={false}>
        <MappedinInfo>
          <ImageContainer>
            <img src={getUrl(mappedinLogoSrc)} alt="Mappedin Logo" />
          </ImageContainer>
          <Address>
            <span>(519) 594 0102</span>
            <span>460 Phillip St Suite 300</span>
            <span>Waterloo, Ontario, N2L 5J2</span>
          </Address>
          <SocialIconsContainer>
            <a
              href={externalLinks.facebook}
              target="_blank"
              rel="noreferrer nofollow"
            >
              <img src={getUrl(fbIcon)} alt="Link to Mappedin Facebook" />
            </a>
            <a
              href={externalLinks.linkedin}
              target="_blank"
              rel="noreferrer nofollow"
            >
              <img src={getUrl(linkedinIcon)} alt="Link to Mappedin Linkedin" />
            </a>
            <a
              href={externalLinks.twitter}
              target="_blank"
              rel="noreferrer nofollow"
            >
              <img src={getUrl(twitterIcon)} alt="Link to Mappedin Twitter" />
            </a>
            <a
              href={externalLinks.instagram}
              target="_blank"
              rel="noreferrer nofollow"
            >
              <img
                src={getUrl(instagramIcon)}
                alt="Link to Mappedin Instagram"
              />
            </a>
          </SocialIconsContainer>
        </MappedinInfo>
        <Copyright>
          <span>
            © {new Date().getFullYear()} Mappedin <br /> All Rights Reserved.
          </span>
          <br />
          <a
            href={externalLinks.hubspot.privacyPolicy}
            target="_blank"
            rel="noreferrer nofollow"
          >
            Privacy Policy
          </a>{" "}
          <span className="divider">|</span> <br className="accessibilityBr" />
          <a
            href={externalLinks.hubspot.accessibility}
            target="_blank"
            rel="noreferrer nofollow"
          >
            Accessibility
          </a>{" "}
          <span className="divider">|</span> <br className="termsBr" />
          <a
            href={externalLinks.hubspot.terms}
            target="_blank"
            rel="noreferrer nofollow"
          >
            Terms & Conditions
          </a>{" "}
        </Copyright>
        <DividingLine />
        {/* EMAIL SIGNUP */}
        <Title>
          Sign up for the latest industry updates, resources, and news
        </Title>
        <EmailSignupForm />
        <SiteNavigationContainer>
          {/* PRODUCTS */}
          <SiteNavListGroup>
            <SiteNavGroupTitle>Products</SiteNavGroupTitle>
            <SiteNavItem to="/mapping/applications/">
              Pre-Built Solutions
            </SiteNavItem>
            <SiteNavItem to="/mapping/developer-tools/">
              Build Your Own
            </SiteNavItem>
            <SiteNavItem to="/indoor-mapping-software/">
              Indoor Mapping
              <br />
              Solutions
            </SiteNavItem>
          </SiteNavListGroup>
          {/* DOCUMENTATION */}
          <SiteNavListGroup>
            <SiteNavGroupTitle>Documentation</SiteNavGroupTitle>
            <SiteNavItem to="https://developer.mappedin.com">
              Developer Portal
            </SiteNavItem>
          </SiteNavListGroup>
          {/* RESOURCES */}
          <SiteNavListGroup>
            <SiteNavGroupTitle>Resources</SiteNavGroupTitle>
            <SiteNavItem to="/blog/">Blog</SiteNavItem>
            <SiteNavItem to={externalLinks.hubspot.newsroom}>
              Newsroom
            </SiteNavItem>
            <SiteNavItem to="/partner-program/">Partner Program</SiteNavItem>
          </SiteNavListGroup>
          {/* COMPANY */}
          <SiteNavListGroup>
            <SiteNavGroupTitle>Company</SiteNavGroupTitle>
            <SiteNavItem to="/about/">About</SiteNavItem>
            <SiteNavItem to="/careers/">Careers</SiteNavItem>
            <SiteNavItem to="/security/">Security</SiteNavItem>
          </SiteNavListGroup>
          {/* INDUSTRIES */}
          <IndustriesListGroup>
            <SiteNavGroupTitle>Industries</SiteNavGroupTitle>
            <NavListItemGrid>
              <SiteNavItem to="/industries/malls/">Malls</SiteNavItem>
              <SiteNavItem to="/industries/retail/">Retail</SiteNavItem>
              <SiteNavItem to="/industries/stadiums/">Stadiums</SiteNavItem>
              <SiteNavItem to="/industries/grocery/">Grocery</SiteNavItem>
              <SiteNavItem to="/industries/offices/">Offices</SiteNavItem>
              <SiteNavItem to="/industries/city-districts/">
                City Districts
              </SiteNavItem>
              <SiteNavItem to="/industries/colleges-and-universities/">
                Campuses
              </SiteNavItem>
              <SiteNavItem to="/industries/theme-parks/">
                Theme Parks
              </SiteNavItem>
              <SiteNavItem to="/industries/hospitals-healthcare/">
                Healthcare
              </SiteNavItem>
              <SiteNavItem to="/industries/warehouses/">Warehouses</SiteNavItem>
              <SiteNavItem to="/industries/transportation-hubs/">
                Transportation Hubs
              </SiteNavItem>
              <SiteNavItem to="/industries/">See All</SiteNavItem>
            </NavListItemGrid>
          </IndustriesListGroup>
        </SiteNavigationContainer>
      </Grid>
    </FooterWrapper>
  )
}

export default React.memo(Footer)
